import "./App.css";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import Dashboard from "./pages/Dashboard";
import Login from "./pages/Login";
import MainLayout from "./components/MainLayout";
import { PrivateRoutes } from "./routing/PrivateRoutes";
import { OpenRoutes } from "./routing/OpenRoutes";
import { useEffect, useState } from "react";
import CarBrands from "./pages/CarBrands";
import LocalUnits from "./pages/LocalUnits";
import OverseasList from "./pages/OverseasList";
import EnrouteList from "./pages/EnrouteList";
import Team from "./pages/Team";
import TeamSinglePage from "./pages/TeamSinglePage";
 import WhatsappPage from "./pages/WhatsappPage";
import MyLeadsPage from "./pages/MyLeadsPage";
import AddTeam from "./pages/AddTeam";
import ResetPassword from "./pages/ResetPassword";

// add this page
import FacebookLeadsPage from "./pages/FacebookLeadsPage";
import WhatsappLeadsPage from "./pages/WhatsappLeadsPage";
import AgentWhatsappChatPage from "./pages/AgentChat";
import AgentsWhatsappPage from "./pages/AgentsWhatsapp";
import AgentsActiveCampaigns from "./pages/AgentsActiveCampaigns";
import TiktokLeadsPage from "./pages/TiktokLeads";

function App() {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setLoading(false);
    }, 1000);

    return () => clearTimeout(timer);
  }, []);

  const storedUser = localStorage.getItem("user")
    ? JSON.parse(localStorage.getItem("user"))
    : null;

  const role = storedUser?.role;

  return (
    <Router>
      {loading ? (
        <div className="loading-overlay">
          <div className="spinner"></div>
        </div>
      ) : (
        <Routes>
          <Route
            path="/"
            element={
              <OpenRoutes>
                <Login />
              </OpenRoutes>
            }
          />

          <Route
            path="/reset-password/:token"
            element={
              <OpenRoutes>
                <ResetPassword />
              </OpenRoutes>
            }
          />

          <Route
            path="/admin"
            element={
              <PrivateRoutes allowedRoles={["admin", "employee"]}>
                <MainLayout />
              </PrivateRoutes>
            }
          >
            <Route
              index
              element={
                <Navigate
                  to={role === "employee" ? "my-leads" : "dashboard"}
                  replace
                />
              }
            />

            <Route
              path="dashboard"
              element={
                <PrivateRoutes allowedRoles={["admin"]}>
                  <Dashboard />
                </PrivateRoutes>
              }
            />

            <Route
              path="my-leads"
              element={
                <PrivateRoutes allowedRoles={["employee"]}>
                  <MyLeadsPage />
                </PrivateRoutes>
              }
            />
            <Route 
            path="agent-whatsapp/:phone"
             element={
              <PrivateRoutes allowedRoles={["employee"]}>
                <AgentWhatsappChatPage />
              </PrivateRoutes>
             
             } />
          <Route 
            path="agent-whatsapp"
             element={
              <PrivateRoutes allowedRoles={["employee"]}>
                <AgentsWhatsappPage />
              </PrivateRoutes>
             
             } />
           <Route 
            path="active-campaigns"
             element={
              <PrivateRoutes allowedRoles={["employee"]}>
                <AgentsActiveCampaigns />
              </PrivateRoutes>
             
             } />

        

            {/* Leads children */}
            <Route
              path="leads/whatsapp"
              element={
                <PrivateRoutes allowedRoles={["admin"]}>
                  <WhatsappLeadsPage />
                </PrivateRoutes>
              }
            />

            <Route
              path="leads/facebook"
              element={
                <PrivateRoutes allowedRoles={["admin"]}>
                  <FacebookLeadsPage />
                </PrivateRoutes>
              }
            />
             <Route
              path="leads/tiktok"
              element={
                <PrivateRoutes allowedRoles={["admin"]}>
                  <TiktokLeadsPage />
                </PrivateRoutes>
              }
            />

            <Route
              path="team"
              element={
                <PrivateRoutes allowedRoles={["admin"]}>
                  <Team />
                </PrivateRoutes>
              }
            />

            <Route
              path="add-team"
              element={
                <PrivateRoutes allowedRoles={["admin"]}>
                  <AddTeam />
                </PrivateRoutes>
              }
            />

            <Route
              path="team/:id"
              element={
                <PrivateRoutes allowedRoles={["admin"]}>
                  <TeamSinglePage />
                </PrivateRoutes>
              }
            />

            {/* WhatsApp messenger */}
            <Route
              path="whatsapp"
              element={
                <PrivateRoutes allowedRoles={["admin"]}>
                  <WhatsappPage />
                </PrivateRoutes>
              }
            />

        
        

           
          </Route>
        </Routes>
      )}
    </Router>
  );
}

export default App;